import React, { useState } from "react";
import { connect } from "react-redux";
import Countly from "countly-sdk-web";

import authActions from "../../redux/auth/action";
import dashboardActions from "../../redux/dashboard/action";
import historyActions from "../../redux/history/action";
import "./styles.css";
import dummyProfile from "../../assets/icons/pro_menu_grey.png";
import api from "../../config/api";
import CustomLoader from "../CustomLoader/CustomLoader";
import Ink from "react-ink";
import switchIcon from "../../assets/icons/switch_dashboard.svg";
import { findBaseURL } from "../../config/helpers";

function Header({
  openSidebar,
  user,
  removeUser,
  localHistory,
  showLoader,
  hideLoader,
  customRef,
  dashboardActions,
  setHistory,
  closeSidebar,
  activeDashboard,
}) {
  const [menu, setMenu] = useState(false);
  const [isLoading] = useState(false);

  customRef({ setMenu });

  const getFullName = () => {
    if (!user) return "user";
    return user.User.firstName + " " + user.User.surname;
  };

  const getProfilePic = () => {
    if (!user) return "";
    else if (user.profile.PICTURE_IMAGE)
      return "data:image/png;base64," + user.profile.PICTURE_IMAGE;
    return dummyProfile;
  };

  const navigate = (route) => {
    localHistory.push(route);
    setHistory(localHistory);
    openSidebar();
    closeSidebar();
  };

  const logoutUser = async () => {
    try {
      showLoader();
      await api.logout(null, user.token);
      sessionStorage.removeItem("user");
      Countly.q.push([
        "logout",
        {
          key: "click",
          count: 1,
        },
      ]);

      navigate("/login");
      removeUser();
      const newURL = findBaseURL(window.location.href);
      window.location.replace(newURL);
    } catch (e) {
      sessionStorage.removeItem("user");
      navigate("/login");
      removeUser();
    }

    hideLoader();
  };

  const switchDashboard = (id) => {
    dashboardActions(id);
    navigate("/");
  };

  const userDashboards = () => {
    const { allRoles, roles } = user;

    return allRoles
      .filter((role) =>
        roles.some((item) =>
          item.roleId === 6 ? false : role.id === item.roleId
        )
      )
      .map((item) => (
        <div
          key={Math.random().toString()}
          onClick={() => switchDashboard(item.id)}
          className={`drop-down-menu ${
            item.id === activeDashboard && "drop-down-menu-disabled"
          }`}
        >
          <img alt="logout-icon" src={switchIcon} />
          <p>{item.roleName} Dashboard</p>
          <Ink />
        </div>
      ));

    // return allRoles.map(allRoles => {
    //   return roles.map(userRoles => {
    //     if (allRoles.id === userRoles.roleId) {
    //       return (
    //         <div key={userRoles.roleId} className="drop-down-menu">
    //           <img alt="logout-icon" src={switchIcon} />
    //           <p>{allRoles.roleName} Dashboard</p>
    //           <Ink />
    //         </div>
    //       );
    //     }
    //   });
    // });
  };

  return (
    <div className="header-container">
      <div onClick={openSidebar} className="header-menu-icon pr-2">
        <img
          alt="menu"
          src={require("../../assets/icons/menu.svg")}
          width="30px"
        />
      </div>
      <p className="header-text">Hello {getFullName()}</p>
      {menu && (
        <div className="drop-down-menu-container">
          <div className="drop-down-username">
            <p data-name="drop-down-menu-item">{getFullName()}</p>
          </div>
          {userDashboards()}
          <div className="drop-down-menu" onClick={logoutUser}>
            <img
              alt="logout-icon"
              src={require("../../assets/icons/logout.png")}
            />
            <p>Logout</p>
            <Ink />
          </div>
        </div>
      )}
      <div className="d-flex">
        {/* <div className="header-icon-container">
          <label className="notification-count">24</label>
          <img
            className="header-icon-notification"
            alt="notification"
            src={require("../../assets/icons/notification.png")}
          />
        </div> */}
        <div className="header-icon-container-row">
          <div
            style={{ backgroundImage: `url('${getProfilePic()}')` }}
            className="header-icon"
          />
          {/* <img
            alt="profile-placeholder"
            className="header-icon"
            src={getProfilePic()}
          /> */}
          <img
            alt="arrow-down"
            className="caret ml-1"
            src={require("../../assets/icons/arrow-down.svg")}
            onClick={() => {
              setMenu(!menu);
            }}
            data-name="drop-down-menu-item"
          />
        </div>
      </div>
      {isLoading && <CustomLoader />}
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  isSidebar: state.auth.isSidebar,
  localHistory: state.history.localHistory,
  activeDashboard: state.dashboard.active,
});

const mapDispatchToProps = {
  openSidebar: authActions.openSidebar,
  closeSidebar: authActions.closeSidebar,
  removeUser: authActions.removeUser,
  showLoader: authActions.showLoader,
  hideLoader: authActions.hideLoader,
  dashboardActions: dashboardActions.setActiveDashboard,
  setHistory: historyActions.setHistory,
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
